import React from 'react';
import { BiError } from 'react-icons/bi';

export default function ErrorView() {
  return (
    <div className="flex items-center justify-center w-full mt-4 rounded-md ">
      <div className="flex flex-col items-center justify-center gap-2">
        <BiError className="text-5xl text-red-400" />
        <h1 className="tracking-tight text-center text-primary">
          Something Went wrong.
          <br /> Please try again
        </h1>
      </div>
    </div>
  );
}

export function ErrorViewGlobal({ error, resetErrorBoundary }: any) {
  return (
    // <div role="alert">
    //   <p>Something went wrong:</p>
    //   <pre>{error.message}</pre>
    //   <button onClick={resetErrorBoundary}>Try again</button>
    // </div>

    <div
      role="alert"
      className="flex items-center justify-center w-full mt-4 rounded-md "
    >
      <div className="flex flex-col items-center justify-center gap-2">
        <BiError className="text-5xl text-red-400" />
        <h1 className="tracking-tight text-center text-primary">
          <pre>{error.message}</pre>
          <button onClick={resetErrorBoundary}>Try again</button>
        </h1>
      </div>
    </div>
  );
}
